import { useEffect } from "react";

const readUserEmail = () => {
  let email =
    localStorage.getItem("identifier") ||
    localStorage.getItem("device_id_email");

  // Fallback: check inside the parsed userData object
  if (!email || !email.includes("@")) {
    const rawUserData = localStorage.getItem("userData");
    if (rawUserData) {
      const parsedUser = JSON.parse(rawUserData);
      if (parsedUser && parsedUser.email) {
        email = parsedUser.email;
      }
    }
  }

  return email && email.includes("@") ? email.trim() : null;
};

const captureUserEmail = () => {
  if (window.gorgiasDidCaptureEmail) return;

  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise((resolve) => {
        window.addEventListener("gorgias-widget-loaded", () => resolve());
      });

  initGorgiasChatPromise.then(() => {
    try {
      const email = readUserEmail();

      if (email) {
        console.log("Email: ", email);
        window.GorgiasChat.captureUserEmail(email);
        window.gorgiasDidCaptureEmail = true;
      }
    } catch (err) {
      console.error("Error attaching email to Gorgias chat:", err);
    }
  });
};

export default function GorgiasChatLoader() {
  useEffect(() => {
    const loadGorgias = () => {
      if (window.gorgiasDidInit) return;

      const script = document.createElement("script");
      script.src =
        "https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=01GYCBRFJX7H9VAB3T2WNHCZD3";
      script.defer = true;
      document.body.appendChild(script);

      window.gorgiasDidInit = true;

      captureUserEmail();
    };

    const onInteraction = () => {
      loadGorgias();
      window.removeEventListener("scroll", onInteraction);
      window.removeEventListener("click", onInteraction);
    };

    window.addEventListener("scroll", onInteraction, { passive: true });
    window.addEventListener("click", onInteraction, { passive: true });

    return () => {
      window.removeEventListener("scroll", onInteraction);
      window.removeEventListener("click", onInteraction);
    };
  }, []);

  return null;
}
